import { Space } from 'antd';
import Card from 'app/components/Card';
import { Text } from 'app/components/Typography/Text';
import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';

const Block = styled(Space)`
  label {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
    color: rgba(137, 145, 160, 1);
  }
  .ant-typography {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.005em;
    text-align: left;
    color: rgba(35, 43, 58, 1);
  }
  margin-bottom: 8px;
`;

const StyledCard = styled(Card)`
  .ant-card-head {
    border-bottom: none;
    min-height: 20px;
  }
  .ant-card-head-title {
    padding-bottom: 0px;
  }
  .ant-card-body {
    padding-top: 8px;
    padding-bottom: 8px;
    flex-direction: column;
    display: flex;
  }
`;
const CardFactoryBasicInfo = (props: {
  info: {
    factoryName: string;
    factoryLocation: string;
    manDay: number;
    start: moment.Moment | null | undefined;
    end: moment.Moment | null | undefined;
  };
}) => {
  const { info } = props;
  const inspectionPeriodLabel = React.useMemo(() => {
    const args = [];
    if (info.start) {
      args.push(info.start.format('DD/MM/YYYY'));
    }
    if (info.end) {
      args.push(info.end.format('DD/MM/YYYY'));
    }
    return args.join(' - ');
  }, [info]);
  return (
    <StyledCard title="Inspection Detail" bordered={false}>
      <Block direction="vertical" size={4}>
        <label>Factory Location</label>
        <Text>{info?.factoryLocation}</Text>
      </Block>
      <Block direction="vertical" size={4}>
        <label>Mandays</label>
        <Text>{info?.manDay}</Text>
      </Block>
      <Block direction="vertical" size={4}>
        <label>Inspection Period</label>
        <Text>{inspectionPeriodLabel}</Text>
      </Block>
      <Block direction="vertical" size={4}>
        <label>Factory Name</label>
        <Text>{info?.factoryName}</Text>
      </Block>
    </StyledCard>
  );
};

export default CardFactoryBasicInfo;
